export const environment= {
  production: true,
  config: {
    // apiURL: 'http://localhost:8080',
    apiURL: 'https://qsr-staging-api.ukwest.cloudapp.azure.com',
    scanningStudioUrl: 'https://scanning-staging.gulndt.com',

    msalConfig: {
      clientId: 'f9172707-5786-4761-9a8f-54befbed1563',
      authority: 'https://gulndt.b2clogin.com/gulndt.onmicrosoft.com/B2C_1_SignIn_QSR',
      knownAuthorities: ['gulndt.b2clogin.com'],
      redirectUri: 'https://adminstaging-scanning.gulndt.com',
      postLogoutRedirectUri: 'https://adminstaging-scanning.gulndt.com',
      scopes: ['https://gulndt.onmicrosoft.com/api/api.read'],
      Graph_endpoint: 'https://graph.microsoft.com/v1.0/me',
    },
    blobConfig: {
      dataContainer: 'data',
      avatarContainer: 'avatars'
    }
  }
};
